import ReservationPicker from "./services/ReservationPicker";
import Modal from "../modules/Modal";
export default class ServicesSinglePage {
    constructor() {
        this.page = document.querySelector('.single-service');
        if (!this.page) {
            return;
        }
        this.galleryWrapper = this.page.querySelector('.service-gallery');
        this.initReservationForms();
        this.initModals();
    }
    initReservationForms() {
        this.reservationPickers = this.page.querySelectorAll('[data-reservation-picker]');
        if (this.reservationPickers.length) {
            this.reservationPickers.forEach((element) => {
                new ReservationPicker(element);
            });
        }
    }
    initModals() {
        // Initialize gallery modal
        if (this.galleryWrapper) {
            new Modal('gallery-modal');
        }
        // Initialize reservation modal
        const reservationModal = this.page.querySelector('.reservation-modal');
        if (reservationModal) {
            new Modal('reservation-modal');
        }
    }
}
